import { Action } from "@ngrx/store";
import { ProductListAPIResponse } from "../models/productlistresponse.model";

import { ProductAPIResponse } from "../models/productresponse.model";

export enum EProductActions {
  GetProduct = "[Product] Get Product",
  GetAllProduct = "[Product] Get All Product",
  GetSingleProduct = "[Product] Get Single Product",
  GetProductSuccess = "[Product] Get Product Success",
  GetAllProductSuccess = "[Product] Get All Product Success",
  GetSingleProductSuccess = "Product Get Single Product Success",
  ClearProduct = "[Product] Clear Product Success",
}

export class GetProduct implements Action {
  public readonly type = EProductActions.GetProduct;
  constructor(public payload: number) {}
}
export class GetAllProduct implements Action {
  public readonly type = EProductActions.GetAllProduct;
  constructor() {}
}
export class GetSingleProduct implements Action {
  public readonly type = EProductActions.GetSingleProduct;
  constructor(public payload: number) {}
}
export class GetProductSuccess implements Action {
  public readonly type = EProductActions.GetProductSuccess;
  constructor(public payload: ProductListAPIResponse) {}
}
export class GetAllProductSuccess implements Action {
  public readonly type = EProductActions.GetAllProductSuccess;
  constructor(public payload: ProductListAPIResponse) {}
}
export class GetSingleProductSuccess implements Action {
  public readonly type = EProductActions.GetSingleProductSuccess;
  constructor(public payload: ProductAPIResponse) {}
}
export type ProductActions =
  | GetProduct
  | GetAllProduct
  | GetSingleProductSuccess
  | GetSingleProduct
  | GetProductSuccess
  | GetAllProductSuccess;
